/**
 * Register the TeamFit service worker (PWA).
 * - Skips in non-production unless `?sw=1` is passed (so dev/hot-reload stays clean).
 * - Listens for new SWs and reloads once activated so users always get fresh code.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isHttps = window.location.protocol === "https:";
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const forceSw = new URLSearchParams(window.location.search).get("sw") === "1";
  if ((!isHttps || isLocal) && !forceSw) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Auto-update: when a new SW is waiting, tell it to skip waiting.
        if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              reg.waiting && reg.waiting.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        /* silent — SW is best-effort */
      });

    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
